export default __webpack_public_path__ + "da5e1c21aea5c9b703a591608ce17ec7.svg";